import { CheckIconSvg } from "components/icons/CheckIconSvg";
import { FC, InputHTMLAttributes } from "react";

export const Radio: FC<InputHTMLAttributes<HTMLInputElement>> = ({
  children,
  ...inputProps
}) => {
  return (
    <label className="cursor-pointer flex items-center gap-2 [&_:checked~.not-checked]:hidden [&_:checked~.is-checked]:flex">
      <input className="hidden" type="radio" {...inputProps}></input>
      <div className="not-checked border border-secondary rounded-full h-5 w-5 bg-white" />
      <div className="is-checked justify-center items-center hidden rounded-full h-5 w-5 bg-primary">
        <CheckIconSvg />
      </div>
      {children}
    </label>
  );
};
